import script from "./useLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./useLayout.vue?vue&type=script&setup=true&lang=js"

import "./useLayout.vue?vue&type=style&index=0&id=6fa66fb4&lang=scss&scoped=true"

import exportComponent from "/Users/yangsonglin/Desktop/桌面/代码系列/畅一科技/管理系统/录单系统/management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa66fb4"]])

export default __exports__